<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2 class="mb-2">last_button</h2>
          <input v-model="last_button.data" type="text" class="form-input"/>

          <div v-for="(page, index) in pages" :key="index">
            <div v-if="page.button">
              <h2 class="mt-5 mb-2">Button Data</h2>
              <input v-model="page.button.data" type="text" class="form-input"/>
            </div>
            <div v-if="page.button_2 && page.button_2.data">
              <h2 class="mt-5 mb-2">Button 2</h2>
              <input v-model="page.button_2.data" type="text" class="form-input"/>
            </div>
            <div v-if="page.type === 'image'">
              <h2 class="mt-5 mb-2">Image URL</h2>
              <input v-model="page.image" type="text" class="form-input"/>
            </div>
          </div>

          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Api Domains
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      last_button: this.config.variants[0].value.last_button,
      pages: this.config.variants[0].value.pages,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          "variants": [
            {
              "id": this.config.variants[0].id,
              "weight": this.config.variants[0].weight,
              "value": {
                "button_text": this.config.variants[0].value.button_text,
                "last_button": this.last_button,
                "toolbar_title": this.config.variants[0].value.toolbar_title,
                "pages": this.pages
              }
            }
          ]
        },
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    containsImage(text) {
      return text.toLowerCase().includes('image');
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
